// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__C2HYs","footer":"Form_footer__9LWXZ"};